<template>
  <router-view></router-view>
</template>

<script>

export default {
  props: {},
  setup() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped></style>
